<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Début<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="fin" class="font-light" >Fin<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.endDate" placeholder="" name="fin" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="poste" class="font-light" >Poste<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.poste" placeholder="Ingénieur mobile" name="poste" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="direction" class="font-light" >Direction<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.direction" placeholder="Technique" name="direction" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Enregistrer</span>
                </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
                <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                    <div class="mb-24 flex justify-center">
                        <img src="../../../assets/lce.png" alt="logo lce" class="w-[200px] h-auto"/>
                    </div>
                <h2 class="text-3xl font-medium text-center mb-[70px] text-[#c00001] underline">ATTESTATION DE STAGE</h2>
                <p class="mb-12 text-gray-700 text-justify">
                    Nous soussignés, <span class="font-semibold">LA LOCOMOTIVE</span> en abrégé (<span class="font-semibold">LCE</span>), Société à Responsabilité Limitée unipersonnelle (SARLU), au capital d'UN MILLION (1.000.000) de FCFA, immatriculée au registre du commerce et du crédit mobilier d'Abidjan -Plateau sous le numéro CI-ABJ-2018-B-24483, sise à Abidjan-Cocody les deux-plateaux, Angré nouveau-CHU BP 995 Abidjan 27, Tél. : 05 46 66 77 66, Représentée aux fins des présentes par M. <span class="font-semibold">COULIBALY Lonan</span>, son Gérant,
                </p>
                <p class="mb-14 text-gray-700 leading-[2]">
                    Attestons par la présente que Monsieur / Madame <span class="font-bold">{{ form.nom ?? "………………………" }}</span>, a effectué un stage au sein de notre société du <span class="font-bold">{{ form.startDate ?? "…………" }}</span> au <span class="font-bold">{{ form.endDate ?? "…………………" }}</span>.
                    en qualité de <span class="font-bold">{{ form.poste ?? "………….." }}</span> à <span class="font-semibold">la direction</span> <span class="font-bold">{{ form.direction ?? "……………" }}</span>.
                </p>
                <p class="mb-4 text-gray-700 mt-14 font-semibold leading-[1.9] text-justify">
                    En foi de quoi, il lui est délivré la présente attestation pour servir et valoir ce que de droit.
                </p>
                <div class="flex justify-end mt-36">
                    <div class="text-left">
                        <p class="text-gray-700 mb-8">Fait à <span class="font-bold">……</span>, le <span class="font-bold">.../…/…</span>.</p>
                        <p class="text-gray-700">Direction des Ressources Humaines</p>
                    </div>
                </div>

                <p class="text-center mt-52 text-gray-700">
                    <span class="font-semibold">LA LOCOMOTIVE</span> (SARLU) Société au capital d’UN MILLION 1.000.000 de FCFA <br> 
                    CC :1847932 J / RC/ CI-ABJ-2018-B-24483, sise à Abidjan-Cocody les deux-plateaux, Angré <br> nouveau-CHU BP 995 Abidjan 27, Tél. : 05 46 66 77 66.

                </p>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "AttestStage",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                startDate: null,
                endDate: null,
                poste: null,
                direction: null
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.poste = null;
            this.form.startDate = null;
            this.form.endDate = null;
            this.form.direction = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":4,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    }
}
</script>